import React from 'react';
import { FiCheckCircle, FiClock, FiFileText } from 'react-icons/fi';
import { API_BASE_URL } from '../../../utils/api';

export default function SubmissionsTable({ submissions }) {
    if (submissions.length === 0) {
        return (
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 text-center">
                <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-400">
                    <FiFileText size={24} />
                </div>
                <h3 className="text-gray-900 font-bold mb-1">No Submissions Yet</h3>
                <p className="text-gray-500 text-sm">Upload a payment slip to get started.</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
                <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Recent Submissions</h3>
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-left">
                    <thead>
                        <tr className="text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-50">
                            <th className="px-6 py-4">Submission Date</th>
                            <th className="px-6 py-4">Course / Month</th>
                            <th className="px-6 py-4">Amount</th>
                            <th className="px-6 py-4">Status</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {submissions.map((sub) => (
                            <tr key={sub.id} className="hover:bg-gray-50/50 transition-colors">
                                <td className="px-6 py-4 text-sm font-medium text-gray-600">
                                    {new Date(sub.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4">
                                    <p className="text-sm font-bold text-gray-900">{sub.class_name}</p>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wide">{sub.month_name}</p>
                                </td>
                                <td className="px-6 py-4 text-sm font-bold text-gray-900">LKR {sub.amount}</td>
                                <td className="px-6 py-4">
                                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider ${sub.status === 'Approved' ? 'bg-green-100 text-green-700' :
                                        sub.status === 'Rejected' ? 'bg-red-100 text-red-700' :
                                            'bg-blue-100 text-blue-700'
                                        }`}>
                                        {sub.status === 'Approved' ? <FiCheckCircle /> : <FiClock />}
                                        {sub.status}
                                    </span>
                                    {sub.slip_url && (
                                        <button
                                            onClick={() => window.open(`${API_BASE_URL}/${sub.slip_url}`, '_blank')}
                                            className="ml-4 text-blue-600 hover:text-blue-700 text-[10px] font-bold uppercase tracking-wider underline"
                                        >
                                            View Slip
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="md:hidden divide-y divide-gray-100">
                {submissions.map((sub) => (
                    <div key={sub.id} className="p-4 flex flex-col gap-3">
                        <div className="flex justify-between items-start">
                            <div>
                                <h4 className="font-bold text-gray-900 text-sm">{sub.class_name}</h4>
                                <p className="text-xs text-blue-600 font-bold uppercase mt-1">{sub.month_name}</p>
                            </div>
                            <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[10px] font-bold uppercase tracking-wide ${sub.status === 'Approved' ? 'bg-green-100 text-green-700' :
                                sub.status === 'Rejected' ? 'bg-red-100 text-red-700' :
                                    'bg-blue-100 text-blue-700'
                                }`}>
                                {sub.status}
                            </span>
                        </div>

                        <div className="flex justify-between items-center text-xs text-gray-500 pt-2 border-t border-gray-50 border-dashed">
                            <div className="flex flex-col">
                                <span className="uppercase tracking-wider text-[9px] font-bold text-gray-400">Amount</span>
                                <span className="font-bold text-gray-900 text-sm">LKR {sub.amount}</span>
                            </div>
                            <div className="flex flex-col text-right">
                                <span className="uppercase tracking-wider text-[9px] font-bold text-gray-400">Date</span>
                                <span className="font-medium">{new Date(sub.created_at).toLocaleDateString()}</span>
                            </div>
                        </div>

                        {sub.slip_url && (
                            <button
                                onClick={() => window.open(`${API_BASE_URL}/${sub.slip_url}`, '_blank')}
                                className="w-full py-2 mt-1 border border-blue-100 text-blue-600 rounded-lg text-xs font-bold uppercase hover:bg-blue-50 transition-colors"
                            >
                                View Payment Slip
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
